<script>
import PalavraComponent from '@/components/Mosaico/Palavras/PalavraComponent.vue'
import words from './Palavras/words.json'

// TODO: descomentar isso para funcionar API
//import colaboracoes from "@/views/Colaboracoes.vue";
import {apiClient} from "@/services/api";

const timeAnimation = 2 * 60;
const nViews = 1.0;
const k = 2;
const sizeArrayWords = 5;
const delays = [45, 45, 45, 45, 45, 45, 45];
const freeSpaceHeight = 300;
const currentWidth = window.screen.availWidth;
const fontController = 1920 - window.screen.availWidth <= 640 ? 45/640 * (1920 - window.screen.availWidth) : 0; //constantes para alterar valores e manter dentro da tela na responsividade
const maxWords = 7;
const fontsWords = ['Avenir', 'Charlotte', 'Charlotte','Charlotte', 'Trattatello', 'Charlotte', 'Avenir'];
const animations = ['4', '2', '3', '1', '2', '2', '4' ]
const sizesWords = [currentWidth/(120 + fontController), currentWidth/(384 + fontController), currentWidth/(213 + fontController),  currentWidth/(213 + fontController),  currentWidth/(384 + fontController), currentWidth/(147 + fontController),  currentWidth/(147 + fontController)];
const rows = [12, 5, 7, 7, 5, 12, 12];
const negativeMarginPercentual = [0.35, 0.25, 0.25, 0.25, 0.5, 0.5, 0.25];
const marginLeftPerLetter = [0.065, 0.01, 0.015, 0.01, 0.015, 0.030, 0.045];
const maxLetterInSpace = [15, 40, 14, 30, 22, 30, 15]

export default {
  components: {
    PalavraComponent
  },
  data() {
    return {
      words,
      wordsWithLength : [],
      colaboracoes: words,
      wordsPrint: [],
      maxLetterInSpace: maxLetterInSpace,
      nViews: nViews ? nViews : 1,
      timeAnimation: timeAnimation,
      rows: rows,
      sizesWords: sizesWords,
      k: k,
      freeSpaceHeight: freeSpaceHeight,
      sizeArrayWords: sizeArrayWords,
      fontsWords: fontsWords,
    }
  },
  beforeMount() {
    this.fetchMosaicoData().then(() => {
      setInterval(() => {
        this.fetchMosaicoData();
      }, this.timeAnimation * 1000)
    });
  },
  methods: {
    wordsRandom: function () {
      let randomWords = this.randomWordsSelection(this.colaboracoes);
      if( randomWords.length > 0) {
        let result =  randomWords.map((word, index) => {
          return {
            text: word.dsc_texto_colaboracao,
            textLength: word.dsc_texto_colaboracao.length,
            delay: delays[index],
            length: sizesWords[index],
            font: fontsWords[index],
            animationCod: animations[index],
            negativeMargin: negativeMarginPercentual[index],
            marginLeft: marginLeftPerLetter[index]
          }
        });

        return result;
      }
      return {};
    },
    randomWordsSelection: function (words) {
      const randomWords = [];
      if (words.length > 0){
        for(let i = 0; i < maxWords; i++){
          randomWords.push(words[Math.floor(Math.random() * words.length)]);
        }
        return randomWords;
      }
      return randomWords
    },
    async fetchMosaicoData() {
      //TODO: descomentar isso para funcionar API
       const cod_producao = JSON.parse(localStorage.getItem("@socialcam/selected_option_production"));
       const first_column = await apiClient.get(`/ColaboracoesModeradaXml/${cod_producao}/1`)
       const second_column = await apiClient.get(`/ColaboracoesModeradaXml/${cod_producao}/2`);
       const updatedColabs = [
         ...first_column.data.colaboracoes_moderadas,
         ...second_column.data.colaboracoes_moderadas,
      ]
      this.colaboracoes = Object.values({...updatedColabs});
      this.wordsPrint = this.wordsRandom();
    },
  }
}

</script>

<template>
    <v-container fluid class="pa-0 ma-0 container-word h-100 w-100">
      <v-row class="pa-0 ma-0 h-100 w-100">
        <v-col class="pa-5 ma-0 w-100 h-100">
          <v-card v-if="wordsPrint.length > 0" class="elevation-0 card flex-nowrap bg-red w-100 h-100 pa-0 ma-0">
            <v-row>
              <v-col v-if="rows[0] != 0" :cols="rows[0]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[0].text"
                    :textLength="wordsPrint[0].textLength"
                    :fontSize="wordsPrint[0].length + 'rem'"
                    :del="wordsPrint[0].delay + 's'"
                    :fontFace="wordsPrint[0].font"
                    :animation-cod="wordsPrint[0].animationCod"
                    :negative-margin="wordsPrint[0].negativeMargin"
                    :margin-left="wordsPrint[0].marginLeft * (wordsPrint[0].text.length - this.maxLetterInSpace[0])"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="rows[1] != 0" :cols="rows[1]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[1].text"
                    :textLength="wordsPrint[1].textLength"
                    :fontSize="wordsPrint[1].length + 'rem'"
                    :del="wordsPrint[1].delay + 's'"
                    :fontFace="wordsPrint[1].font"
                    :animation-cod="wordsPrint[1].animationCod"
                    :negative-margin="wordsPrint[1].negativeMargin"
                    :margin-left="wordsPrint[1].marginLeft * (wordsPrint[1].text.length - this.maxLetterInSpace[1])"
                />
              </v-col>
              <v-col v-if="rows[2] != 0" :cols="rows[2]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[2].text"
                    :textLength="wordsPrint[2].textLength"
                    :fontSize="wordsPrint[2].length + 'rem'"
                    :del="wordsPrint[2].delay + 's'"
                    :fontFace="wordsPrint[2].font"
                    :animation-cod="wordsPrint[2].animationCod"
                    :negative-margin="wordsPrint[2].negativeMargin"
                    :margin-left="wordsPrint[2].marginLeft * (wordsPrint[2].text.length - this.maxLetterInSpace[2])"
                />
              </v-col>
            </v-row>
            <div class="logo-space"></div>
            <v-row>
              <v-col v-if="rows[3] != 0" :cols="rows[3]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[3].text"
                    :textLength="wordsPrint[3].textLength"
                    :fontSize="wordsPrint[3].length + 'rem'"
                    :del="wordsPrint[3].delay + 's'"
                    :fontFace="wordsPrint[3].font"
                    :animation-cod="wordsPrint[3].animationCod"
                    :negative-margin="wordsPrint[3].negativeMargin"
                    :margin-left="wordsPrint[3].marginLeft * (wordsPrint[3].text.length - this.maxLetterInSpace[3])"
                />
              </v-col>
              <v-col v-if="rows[4] != 0" :cols="rows[4]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[4].text"
                    :textLength="wordsPrint[4].textLength"
                    :fontSize="wordsPrint[4].length + 'rem'"
                    :del="wordsPrint[4].delay + 's'"
                    :fontFace="wordsPrint[4].font"
                    :animation-cod="wordsPrint[4].animationCod"
                    :negative-margin="wordsPrint[4].negativeMargin"
                    :margin-left="wordsPrint[4].marginLeft * (wordsPrint[4].text.length - this.maxLetterInSpace[4])"
                />
              </v-col>

            </v-row>
            <v-row>
              <v-col v-if="rows[5] != 0" :cols="rows[5]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[5].text"
                    :textLength="wordsPrint[5].textLength"
                    :fontSize="wordsPrint[5].length + 'rem'"
                    :del="wordsPrint[5].delay + 's'"
                    :fontFace="wordsPrint[5].font"
                    :animation-cod="wordsPrint[5].animationCod"
                    :negative-margin="wordsPrint[5].negativeMargin"
                    :margin-left="wordsPrint[5].marginLeft * (wordsPrint[5].text.length - this.maxLetterInSpace[5])"
                />
              </v-col>
              <v-col v-if="rows[6] != 0" :cols="rows[6]" justify="center" class="">
                <PalavraComponent
                    class="words"
                    :text="wordsPrint[6].text"
                    :textLength="wordsPrint[6].textLength"
                    :fontSize="wordsPrint[6].length + 'rem'"
                    :del="wordsPrint[6].delay + 's'"
                    :fontFace="wordsPrint[6].font"
                    :animation-cod="wordsPrint[6].animationCod"
                    :negative-margin="wordsPrint[6].negativeMargin"
                    :margin-left="wordsPrint[6].marginLeft * (wordsPrint[6].text.length - this.maxLetterInSpace[6])"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<style scoped lang="scss">
$time: calc(v-bind(timeAnimation) * 1s);
$nViews: v-bind(nViews);

.logo-space{
  width: 100%;
  height: calc(v-bind(freeSpaceHeight) * 1px);
}

.words{
  background-color: rgba(0, 0, 0, 0);
}
.container-word{
  height: 100vh;
  background-color: rgba(0, 0, 0, 1);
}

.card{
  width: calc($nViews * 100vw);
  height: 100% !important;
  background: rgba(0, 0, 0, 0);
  animation: marginLeft $time infinite linear;
}

@keyframes marginLeft {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: calc(calc($nViews - 1) * -100vw);
  }
}
</style>
